import { render, staticRenderFns } from "./TrajectoryColorConfigDialog.vue?vue&type=template&id=60149c1d&scoped=true"
import script from "./TrajectoryColorConfigDialog.vue?vue&type=script&lang=js"
export * from "./TrajectoryColorConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./TrajectoryColorConfigDialog.vue?vue&type=style&index=0&id=60149c1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60149c1d",
  null
  
)

export default component.exports